
import Vue from 'vue'
import { mapState } from 'vuex'
import {
    PROMO_PROJECT_DEFAULT_PAGE_SIZE,
    PROMO_PROJECT_PAGE_SIZES,
    buildPromoProjectIndex,
    filterPromoProjects,
    paginateItems,
    ruProjectsCount,
} from '@/helpers/promo/projectSelect'
import type { PromoProjectOption } from '@/helpers/promo/projectSelect'
import MagnifyIcon from '@/assets/vuetifyIcons/magnify.vue'

export default Vue.extend({
    name: 'PromoProjectSelect',
    components: { MagnifyIcon },
    props: {
        eyebrow: {
            type: String,
            default: 'Активация бонусов',
        },
        title: {
            type: String,
            default: 'Выберите проект, для которого вы хотите активировать бонусы',
        },
        text: {
            type: String,
            default: 'Бонусы из промо‑ссылки сохранятся автоматически и будут применены к выбранному проекту.',
        },
        continueLabel: {
            type: String,
            default: 'Перейти к подключению',
        },
        showCancel: {
            type: Boolean,
            default: false,
        },
        cancelLabel: {
            type: String,
            default: 'Назад',
        },
        allowedProjects: {
            type: Array,
            default: null,
        },
        disableOnboardingProjects: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        searchDraft: '',
        searchQuery: '',
        searchTimer: null as ReturnType<typeof setTimeout> | null,
        page: 1,
        pageSize: PROMO_PROJECT_DEFAULT_PAGE_SIZE,
        selectedId: '' as string,
        pageSizeOptions: [...PROMO_PROJECT_PAGE_SIZES],
    }),
    computed: {
        ...mapState(['projects']),
        index(): readonly PromoProjectOption[] {
            return buildPromoProjectIndex(this.allowedProjects || this.projects, {
                disableOnboarding: this.disableOnboardingProjects,
            })
        },
        showPageSize(): boolean {
            return this.index.length > PROMO_PROJECT_DEFAULT_PAGE_SIZE
        },
        filtered(): PromoProjectOption[] {
            return filterPromoProjects(this.index, this.searchQuery)
        },
        isSearchEmpty(): boolean {
            return Boolean((this.searchQuery || '').trim()) && this.filtered.length === 0
        },
        totalPages(): number {
            return Math.max(1, Math.ceil(this.filtered.length / this.pageSize) || 1)
        },
        pageItems(): PromoProjectOption[] {
            return paginateItems(this.filtered, this.page, this.pageSize)
        },
        selectedProject(): PromoProjectOption | null {
            if (!this.selectedId) return null
            return this.index.find((item) => item.id === this.selectedId) || null
        },
        canContinue(): boolean {
            return Boolean(this.selectedProject && !this.selectedProject.disabled)
        },
    },
    watch: {
        searchDraft() {
            this.onSearchInput()
        },
        pageSize() {
            this.page = 1
        },
        filtered() {
            if (this.page > this.totalPages) this.page = this.totalPages
        },
    },
    beforeDestroy() {
        if (this.searchTimer) clearTimeout(this.searchTimer)
    },
    methods: {
        ruProjectsCount,
        onSearchInput() {
            if (this.searchTimer) clearTimeout(this.searchTimer)
            this.searchTimer = setTimeout(() => {
                this.searchQuery = this.searchDraft || ''
                this.page = 1
            }, 180)
        },
        onPageSizeChange(event: Event) {
            const next = Number((event.target as HTMLSelectElement | null)?.value)
            this.pageSize = next > 0 ? next : PROMO_PROJECT_DEFAULT_PAGE_SIZE
        },
        onSelectProject(project: PromoProjectOption) {
            if (project.disabled) return
            this.selectedId = project.id
        },
        onContinue() {
            if (!this.canContinue || !this.selectedId) return
            this.$emit('select', this.selectedId)
        },
    },
})
